import { render } from "./CompanyDetailTadle.vue?vue&type=template&id=89be8700&scoped=true"
import script from "./CompanyDetailTadle.vue?vue&type=script&lang=js"
export * from "./CompanyDetailTadle.vue?vue&type=script&lang=js"

import "./CompanyDetailTadle.vue?vue&type=style&index=0&id=89be8700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89be8700"]])

export default __exports__